<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="系统名称" name="systemName">
        <div class="table-box">
          <el-table class="my-machine-table" :data="textSystemNameTable" border>
            <el-table-column label="开关" width="80px">
              <template slot-scope="scope" v-if="scope.row.id !== -1">
                <el-switch :disabled="!hasCommitPermission" v-model="scope.row.sw"/>
              </template>
            </el-table-column>
            <el-table-column prop="pName" label="到访区域"></el-table-column>
            <el-table-column prop="subName0" label="到访子区域"></el-table-column>
            <el-table-column prop="subName" label="到访地址"></el-table-column>
            <el-table-column label="系统名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.ctn" :disabled="!hasCommitPermission || !scope.row.sw"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="center">
          <el-button type="primary" @click="tableNameSaveClick()"
                     :disabled="!hasCommitPermission">保存
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="单位欢迎词" name="welcome">
        <div class="table-box">
          <el-table :data="textWelcomePageTable" class="my-machine-table" border>
            <el-table-column label="开关" width="80px">
              <template slot-scope="scope" v-if="scope.row.id !== -1">
                <el-switch :disabled="!hasCommitPermission" v-model="scope.row.sw"/>
              </template>
            </el-table-column>
            <el-table-column prop="pName" label="到访区域"></el-table-column>
            <el-table-column prop="subName0" label="到访子区域"></el-table-column>
            <el-table-column prop="subName" label="到访地址"></el-table-column>
            <el-table-column label="单位欢迎词">
              <template slot-scope="scope">
                <el-input v-model="scope.row.ctn" :disabled="!hasCommitPermission || !scope.row.sw"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="center">
          <el-button type="primary" @click="welcomePageSaveClick()"
                     :disabled="!hasCommitPermission">保存
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="二维码配置" name="qrcode">
        <div class="table-box">
          <el-table :data="qrInHomeSettingTable" class="my-machine-table" border>
            <el-table-column label="开关" width="80px">
              <template slot-scope="scope" v-if="scope.row.id !== -1">
                <el-switch :disabled="!hasCommitPermission" v-model="scope.row.sw"/>
              </template>
            </el-table-column>
            <el-table-column prop="pName" label="到访区域"></el-table-column>
            <el-table-column prop="subName0" label="到访子区域"></el-table-column>
            <el-table-column prop="subName" label="到访地址"></el-table-column>
            <el-table-column label="二维码上传">
              <template slot-scope="scope">
                <el-upload
                    :disabled="!hasCommitPermission || !scope.row.sw"
                    class="upload-demo"
                    ref="upload"
                    action="#"
                    list-type="picture-card"
                    :on-remove="handleQrChange(scope.row.id)"
                    :on-change="handleQrChange(scope.row.id)"
                    :multiple="false"
                    :file-list="scope.row.picList"
                    :limit="1"
                    :auto-upload="false">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div class="center">
          <el-button type="primary" @click="qrInHomeSaveClick()"
                     :disabled="!hasCommitPermission">保存
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="logo设置" name="logo">
        <div class="table-box">
          <el-table :data="logoTable" class="my-machine-table" border>
            <el-table-column label="开关" width="80px">
              <template slot-scope="scope" v-if="scope.row.id !== -1">
                <el-switch :disabled="!hasCommitPermission" v-model="scope.row.sw"/>
              </template>
            </el-table-column>
            <el-table-column prop="pName" label="到访区域"></el-table-column>
            <el-table-column prop="subName0" label="到访子区域"></el-table-column>
            <el-table-column prop="subName" label="到访地址"></el-table-column>
            <el-table-column label="logo设置">
              <template slot-scope="scope">
                <el-upload
                    :disabled="!hasCommitPermission || !scope.row.sw"
                    class="upload-demo"
                    ref="upload"
                    action="#"
                    list-type="picture-card"
                    :on-remove="handleLogoChange(scope.row.id)"
                    :on-change="handleLogoChange(scope.row.id)"
                    :multiple="false"
                    :file-list="scope.row.picList"
                    :limit="1"
                    :auto-upload="false">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div class="center">
          <el-button type="primary" @click="logoSaveClick()"
                     :disabled="!hasCommitPermission">保存
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="背景设置" name="background">
        <div class="table-box">
          <el-table :data="backgroundTable" class="my-machine-table" border>
            <el-table-column label="开关" width="80px">
              <template slot-scope="scope" v-if="scope.row.id !== -1">
                <el-switch :disabled="!hasCommitPermission" v-model="scope.row.sw"/>
              </template>
            </el-table-column>
            <el-table-column prop="pName" label="到访区域"></el-table-column>
            <el-table-column prop="subName0" label="到访子区域"></el-table-column>
            <el-table-column prop="subName" label="到访地址"></el-table-column>
            <el-table-column label="背景设置">
              <template slot-scope="scope">
                <el-upload
                    :disabled="!hasCommitPermission || !scope.row.sw"
                    class="upload-demo"
                    ref="upload"
                    action="#"
                    list-type="picture-card"
                    :on-remove="handleBgChange(scope.row.id)"
                    :on-change="handleBgChange(scope.row.id)"
                    :multiple="false"
                    :file-list="scope.row.picList"
                    :limit="1"
                    :auto-upload="false">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div class="center">
          <el-button type="primary" @click="backgroundSaveClick()"
                     :disabled="!hasCommitPermission">保存
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="轮播图设置" name="banner">
        <div class="table-box">
          <el-table :data="bannerTable" class="my-machine-table" border>
            <el-table-column label="显示位置" prop="prop" width="200"></el-table-column>
            <el-table-column label="显示图片">
              <template slot-scope="scope">
                <el-upload
                    :disabled="!hasCommitPermission "
                    class="upload-demo"
                    ref="upload"
                    action="#"
                    list-type="picture-card"
                    :on-remove="handleBannerRemove(scope.row.id)"
                    :on-change="handleBannerChange(scope.row.id)"
                    :multiple="false"
                    :limit="1"
                    :file-list="scope.row.picList"
                    :auto-upload="false">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div class="center">
          <el-button type="primary" @click="bannerSaveClick()"
                     :disabled="!hasCommitPermission">保存
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="功能入口设置" name="homeEnterSetting">
        <el-form class="main-form" ref="form">
          <div class="tree-box">
            <div class="left-tree">
              <div class="title">系统所有功能</div>
              <el-tree
                  :data="homeEnterTree"
                  show-checkbox
                  default-expand-all
                  node-key="value"
                  ref="homeEnterTree"
                  highlight-current
                  @check="onCheckTreeChange"

                  :default-checked-keys="homeEnterVales"
                  :props="defaultProps">
              </el-tree>
            </div>
            <div class="right-tree">
              <div class="title">系统选中功能</div>
              <el-tree
                  :data="homeSelectTree"
                  ref="homeSelectTree"
                  default-expand-all
                  node-key="value"
                  highlight-current
                  :props="defaultProps">
              </el-tree>
            </div>
          </div>
          <div class="center">

            <el-button @click="onSaveHomeEnterSetting" type="primary" :disabled="!hasCommitPermission">保存</el-button>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import {getTerminateSettingInfo, setSystemSettingInfo} from "@/api/setting-api";
import {getFileUrl, uploadFile} from "@/utils/fileUploadUtils";
import {getAllArea} from "@/api/device-manager-api";

export default {
  name: "VisitorMachineSetting",
  data() {
    return {
      activeName: "systemName",

      fileBgList: [],
      BgChanged: false,

      homeEnterVales: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      homeSelectTree: [],
      homeEnterTree: [
        {
          label: "登记设置", value: "regist-select", children: [
            {label: "现场登记", value: "local-regest"},
            {label: "身份证登记", value: "idcard-regest"},
          ]
        },
        {
          label: "签到设置", value: "enter-select", children: [
            {label: "二维码签到", value: "qrcode-enter"},
            {label: "身份证签到", value: "idcard-enter"},
            {label: "手机号签到", value: "phone-enter"},
            {label: "访客码签到", value: "code-enter"},
          ]
        },
        {
          label: "签离设置", value: "leave-select", children: [
            {label: "二维码签离", value: "qrcode-leave"},
            {label: "身份证签离", value: "idcard-leave"},
            {label: "手机号签离", value: "phone-leave"},
            {label: "访客码签离", value: "code-leave"},
          ]
        },
      ],

      homeEnterData: [
        {value: 'on-site-registration', label: '现场登记'},
        {value: 'visitor-code-come', label: '访客码签到'},
        {value: 'visitor-code-leave', label: '访客码签离'},
        {value: 'qr-code-come', label: '二维码签到'},
        {value: 'qr-code-leave', label: '二维码签离'},
      ],

      homeEnterProp: {
        key: 'value',
        label: 'label',
      },

      textSystemNameTable: [],
      textSystemNameSetting: {},
      textWelcomePageTable: [],
      textWelcomePageSetting: {},
      qrInHomeSettingTable: [],
      qrInHomeSettingSetting: {},
      logoTable: [],
      logoSetting: {},
      backgroundTable: [],
      backgroundSetting: {},
      bannerTable: [],
      bannerSetting: {},

      settingData: null,
      areData: null,
    }
  },

  mounted() {
    getTerminateSettingInfo().then(({data}) => {
      console.log("getTerminateSettingInfo", data)
      if (data.code === 200) {
        this.settingData = data.data
        this.setupData()
      } else {
        console.log("getTerminateSettingInfo false", data.msg)
        this.showServerErrMsg(data.msg)
      }
    }).catch(err => {
      console.error("getTerminateSettingInfo err", err)
      this.showNetErrMsg()
    })

    getAllArea().then(({data}) => {
      console.log("getAllArea", data)
      if (data.code === 200) {
        let areaList = []
        data.data.forEach(item => {
          ;(item.areas || []).forEach(child => {
            areaList.push({...child, parentName: item.name})
          })
        })
        this.areData = areaList
        this.setupData()
      } else {
        console.log("getAllArea false", data.msg)
        this.showServerErrMsg(data.msg)
      }
    }).catch(err => {
      console.error("getAllArea err", err)
      this.showNetErrMsg()
    })

  },

  methods: {

    tableNameSaveClick() {
      this.textSystemNameTable.forEach(row => {
        this.textSystemNameSetting[row.id] = {ctn: row.ctn, sw: row.sw}
      })
      this.doSetSystemSettingInfo("SYSTEM_NAME", JSON.stringify(this.textSystemNameSetting))
    },

    setupSystemName(content, areaData) {
      let textSystemNameTable = []

      textSystemNameTable.push({id: -1, pName: "默认",subName0: "默认",  subName: "默认", ctn: "", sw: true})
      areaData.forEach(item => {
        textSystemNameTable.push({id: item.id, pName: item.parentName, subName0: item.name,  subName: item.address, ctn: "", sw: false})
      })
      textSystemNameTable.forEach(item => {
        let cfg = content[item.id]
        if (cfg) {
          item.ctn = cfg.ctn
          item.sw = cfg.sw
        }
      })
      this.textSystemNameTable = textSystemNameTable
      this.textSystemNameSetting = content

    },

    welcomePageSaveClick() {
      this.textWelcomePageTable.forEach(row => {
        this.textWelcomePageSetting[row.id] = {ctn: row.ctn, sw: row.sw}
      })
      this.doSetSystemSettingInfo("HOME_WELCOME", JSON.stringify(this.textWelcomePageSetting))
    },

    setupWelcomePage(content, areaData) {
      let textWelcomeNameTable = []
      textWelcomeNameTable.push({id: -1, pName: "默认",subName0: "默认", subName: "默认", ctn: "", sw: true})
      areaData.forEach(item => {
        textWelcomeNameTable.push({id: item.id, pName: item.parentName, subName0: item.name,  subName: item.address, ctn: "", sw: false})
      })
      textWelcomeNameTable.forEach(item => {
        let cfg = content[item.id]
        if (cfg) {
          item.ctn = cfg.ctn
          item.sw = cfg.sw
        }
      })
      this.textWelcomePageTable = textWelcomeNameTable
      this.textWelcomePageSetting = content
    },

    qrInHomeSaveClick() {
      let picRows = []
      this.qrInHomeSettingTable.forEach(row => {
        if (!row.changed) {
          this.qrInHomeSettingSetting[row.id] = {ctn: row.ctn, sw: row.sw}
        } else if (row.picList.length === 0) {
          this.qrInHomeSettingSetting[row.id] = {ctn: "", sw: row.sw}
        } else {
          picRows.push(row)
        }
      })

      if (picRows.length === 0) {
        console.log("qrInHomeSaveClick", this.qrInHomeSettingSetting)
        this.doSetSystemSettingInfo("HOME_QR_REGISTER", JSON.stringify(this.qrInHomeSettingSetting))
        return;
      }

      picRows.forEach(row => {
        let qrRegisterPath = `manager/qr-register-${row.id}-${row.picList[0].name}`
        uploadFile(row.picList[0], qrRegisterPath)
        this.qrInHomeSettingSetting[row.id] = {ctn: qrRegisterPath, sw: row.sw}
      })
      console.log("qrInHomeSaveClick", this.qrInHomeSettingSetting)

      this.doSetSystemSettingInfo("HOME_QR_REGISTER", JSON.stringify(this.qrInHomeSettingSetting))
    },

    setupQrInHome(content, areaData) {
      let qrInHomeTable = []
      qrInHomeTable.push({id: -1, pName: "默认", subName0: "默认",  subName: "默认", picList: [], changed: false, ctn: "", sw: true})
      areaData.forEach(item => {
        qrInHomeTable.push({id: item.id, pName: item.parentName, subName0: item.name, subName: item.address, picList: [], changed: false, ctn: "", sw: false})
      })
      qrInHomeTable.forEach(item => {
        let cfg = content[item.id]
        if (cfg) {
          item.ctn = cfg.ctn
          item.sw = cfg.sw
          // 历史遗留的链接配置不是图片，预览会裂图，留空展示（保存时未改动会原样保留）
          if (cfg.ctn && /\.(png|jpe?g|gif|webp|svg)$/i.test(cfg.ctn)) {
            this.setPic(item.picList, cfg.ctn)
          }
        }
      })
      this.qrInHomeSettingTable = qrInHomeTable
      this.qrInHomeSettingSetting = content
    },

    handleQrChange(id) {
      let qrRemove = (file, fileList) => {
        this.qrInHomeSettingTable.forEach(item => {
          if (item.id === id) {
            console.log("handleQrChange", id, file, fileList);
            item.picList = fileList
            item.changed = true
          }
        })
      }
      return qrRemove
    },

    logoSaveClick() {
      let picRows = []
      this.logoTable.forEach(row => {
        if (!row.changed) {
          this.logoSetting[row.id] = {ctn: row.ctn, sw: row.sw}
        } else if (row.picList.length === 0) {
          this.logoSetting[row.id] = {ctn: "", sw: row.sw}
        } else {
          picRows.push(row)
        }
      })

      if (picRows.length === 0) {
        console.log("logoSaveClick", this.logoSetting)
        this.doSetSystemSettingInfo("COMPANY_LOGO", JSON.stringify(this.logoSetting))
        return;
      }

      picRows.forEach(row => {
        let companyLogo = `manager/logo-${row.id}-${row.picList[0].name}`
        uploadFile(row.picList[0], companyLogo)
        this.logoSetting[row.id] = {ctn: companyLogo, sw: row.sw}
      })
      console.log("logoSaveClick", this.logoSetting)

      this.doSetSystemSettingInfo("COMPANY_LOGO", JSON.stringify(this.logoSetting))

    },

    bannerSaveClick() {
      let picRows = []
      this.bannerTable.forEach(row => {
        if (row.picList.length > 0) {
          if (row.changed) {
            let objectKey = `manager/banner-${row.id}-${row.picList[0].name}`
            uploadFile(row.picList[0], objectKey)

            picRows.push(objectKey)
          } else {
            picRows.push(row.name)
          }
        }
      })

      this.doSetSystemSettingInfo("HOME_BANNER_LIST", JSON.stringify(picRows))

    },

    handleLogoChange(id) {
      let logoRemove = (file, fileList) => {
        this.logoTable.forEach(item => {
          if (item.id === id) {
            console.log("handleLogoChange", id, file, fileList);
            item.picList = fileList
            item.changed = true
          }
        })
      }
      return logoRemove
    },

    handleBannerChange(id) {
      let bannerRemove = (file, fileList) => {
        this.bannerTable.forEach(item => {
          if (item.id === id) {
            console.log("handlebannerChange", id, file, fileList);
            item.picList = fileList
            item.changed = true
          }
        })

        let lastItem = this.bannerTable[this.bannerTable.length - 1]
        let newId = lastItem.id + 1
        if (lastItem.picList.length > 0) {
          this.bannerTable.push({
            id: newId,
            prop: "位置" + (this.bannerTable.length + 1),
            name: "",
            picList: [],
            changed: false
          })
        }

      }
      return bannerRemove
    },

    handleBannerRemove(id) {
      let bannerRemove = () => {
        let index = this.bannerTable.findIndex(item => item.id === id)
        this.bannerTable.splice(index, 1)

        for (let i = 0; i < this.bannerTable.length; i++) {
          this.bannerTable[i].prop = "位置" + (i + 1)
        }
        this.bannerTable = [...this.bannerTable]

      }
      return bannerRemove
    },

    updateHomeSelectTree(selectNodeKeys) {
      let selectKeys = selectNodeKeys
      let homeSelectTree = []
      if (selectKeys.includes("local-regest" || selectKeys.includes("idcard-regest"))) {
        let item = {label: "登记设置", value: "regist-select", children: []}
        if (selectKeys.includes("local-regest")) {
          item.children.push({label: "现场登记", value: "local-regest"})
        }
        if (selectKeys.includes("idcard-regest")) {
          item.children.push({label: "身份证登记", value: "idcard-regest"})
        }
        homeSelectTree.push(item)
      }

      if (selectKeys.includes("qrcode-enter" || selectKeys.includes("idcard-enter") || selectKeys.includes("phone-enter") || selectKeys.includes("code-enter"))) {
        let item = {label: "签到设置", value: "enter-select", children: []}
        if (selectKeys.includes("qrcode-enter")) {
          item.children.push({label: "二维码签到", value: "qrcode-enter"})
        }
        if (selectKeys.includes("idcard-enter")) {
          item.children.push({label: "身份证签到", value: "idcard-enter"})
        }
        if (selectKeys.includes("phone-enter")) {
          item.children.push({label: "手机号签到", value: "phone-enter"})
        }
        if (selectKeys.includes("code-enter")) {
          item.children.push({label: "验证码签到", value: "code-enter"})
        }
        homeSelectTree.push(item)
      }

      if (selectKeys.includes("qrcode-leave" || selectKeys.includes("idcard-leave") || selectKeys.includes("phone-leave") || selectKeys.includes("code-leave"))) {
        let item = {label: "签离设置", value: "leave-select", children: []}
        if (selectKeys.includes("qrcode-leave")) {
          item.children.push({label: "二维码签离", value: "qrcode-leave"})
        }
        if (selectKeys.includes("idcard-leave")) {
          item.children.push({label: "身份证签离", value: "idcard-leave"})
        }
        if (selectKeys.includes("phone-leave")) {
          item.children.push({label: "手机号签离", value: "phone-leave"})
        }
        if (selectKeys.includes("code-leave")) {
          item.children.push({label: "访客码签离", value: "code-leave"})
        }
        homeSelectTree.push(item)
      }

      this.homeSelectTree = homeSelectTree
    },

    onCheckTreeChange() {
      let selectKeys = this.$refs.homeEnterTree.getCheckedKeys()
      this.updateHomeSelectTree(selectKeys)
    },

    backgroundSaveClick() {
      let picRows = []
      this.backgroundTable.forEach(row => {
        if (!row.changed) {
          this.backgroundSetting[row.id] = {ctn: row.ctn, sw: row.sw}
        } else if (row.picList.length === 0) {
          this.backgroundSetting[row.id] = {ctn: "", sw: row.sw}
        } else {
          picRows.push(row)
        }
      })
      if (picRows.length === 0) {
        console.log("backgroundSaveClick", this.backgroundSetting)
        this.doSetSystemSettingInfo("HOME_BACKGROUND", JSON.stringify(this.backgroundSetting))
        return;
      }

      picRows.forEach(row => {
        let backgroundPath = `manager/background-${row.id}-${row.picList[0].name}`
        uploadFile(row.picList[0], backgroundPath,)
        this.backgroundSetting[row.id] = {ctn: backgroundPath, sw: row.sw}
      })
      this.doSetSystemSettingInfo("HOME_BACKGROUND", JSON.stringify(this.backgroundSetting))
    },


    setupLogo(content, areaData) {
      let logoTable = []
      logoTable.push({id: -1, pName: "默认", subName0: "默认",  subName: "默认", picList: [], changed: false, ctn: "", sw: true})
      areaData.forEach(item => {
        logoTable.push({
          id: item.id,
          pName: item.parentName,
          subName: item.address,
          subName0: item.name,
          picList: [],
          changed: false,
          ctn: "",
          sw: false
        })
      })
      logoTable.forEach(item => {
        let cfg = content[item.id]
        if (cfg) {
          item.ctn = cfg.ctn
          item.sw = cfg.sw
          if (cfg.ctn) {
            this.setPic(item.picList, cfg.ctn)
          }
        }
      })
      this.logoTable = logoTable
      this.logoSetting = content
    },

    setupBanner(content, areaData) {


      console.log("@@@@@ setupBanner", content, areaData)
      let bannerTable = []
      for (let i = 0; i < content.length; i++) {
        let item = content[i]
        bannerTable.push({id: i, prop: `位置${i + 1}`, name: item, picList: [], changed: false})
        this.setPic(bannerTable[i].picList, item)
      }
      bannerTable.push({
        id: bannerTable.length,
        prop: "位置" + (bannerTable.length + 1),
        name: "",
        picList: [],
        changed: false
      })
      this.bannerTable = bannerTable
      this.bannerSetting = content
    },


    handleBgChange(id) {
      let logoRemove = (file, fileList) => {
        this.backgroundTable.forEach(item => {
          if (item.id === id) {
            console.log("handleBgChange", id, file, fileList);
            item.picList = fileList
            item.changed = true
          }
        })
      }
      return logoRemove
    },

    setupBg(content, areaData) {
      let backgroundTable = []
      backgroundTable.push({id: -1, pName: "默认", subName0: "默认", subName: "默认", picList: [], changed: false, ctn: "", sw: true})
      areaData.forEach(item => {
        backgroundTable.push({
          id: item.id,
          pName: item.parentName,
          subName0: item.name,
          subName: item.address,
          picList: [],
          changed: false,
          ctn: "",
          sw: false
        })
      })
      backgroundTable.forEach(item => {
        let cfg = content[item.id]
        if (cfg) {
          item.ctn = cfg.ctn
          item.sw = cfg.sw
          if (cfg.ctn) {
            this.setPic(item.picList, cfg.ctn)
          }
        }
      })
      this.backgroundTable = backgroundTable
      this.backgroundSetting = content
    },

    setupData() {
      let settingData = this.settingData
      let areData = this.areData
      if (settingData == null || areData == null) {
        return
      }
      console.log("settingData", settingData, areData)
      console.log("areData", areData, areData)
      let textSystemNameContent = {}
      let textWelcomePageContent = {}
      let qrInHomeSettingContent = {}
      let fileLogoContent = {}
      let fileBgContent = {}
      let fileBannerContent = {}

      settingData.forEach(item => {
        switch (item.type) {
          case "SYSTEM_NAME":
            textSystemNameContent = JSON.parse(item.content)
            break
          case "HOME_WELCOME":
            textWelcomePageContent = JSON.parse(item.content)
            break
          case "HOME_QR_REGISTER":
            qrInHomeSettingContent = JSON.parse(item.content)
            break
          case "COMPANY_LOGO":
            fileLogoContent = JSON.parse(item.content)
            break
          case "HOME_BACKGROUND":
            fileBgContent = JSON.parse(item.content)
            break
          case "HOME_ENTER_SETTING":
            this.homeEnterVales = item.content.split("|")
            this.updateHomeSelectTree(this.homeEnterVales)
            break
          case "HOME_BANNER_LIST":
            fileBannerContent = JSON.parse(item.content)
            break
          default:
            break
        }
      })

      this.setupSystemName(textSystemNameContent, areData)
      this.setupWelcomePage(textWelcomePageContent, areData)
      this.setupQrInHome(qrInHomeSettingContent, areData)
      this.setupLogo(fileLogoContent, areData)
      this.setupBanner(fileBannerContent, areData)
      this.setupBg(fileBgContent, areData)
    },

    setPic(fileList, content) {
      let url = getFileUrl(content)
      const index = content.lastIndexOf("/");
      const fileName = content.substring(index + 1);
      fileList.push({name: fileName, url: url})
    },

    doSetSystemSettingInfo(type, content) {
      const postData = {target: "TERMINATE", state: "VALID", type: type, content: content}
      console.log("doSetSystemSettingInfo data:", postData)
      setSystemSettingInfo(postData).then(({data}) => {
        console.log("doSetSystemSettingInfo return", data)
        if (data.code === 200) {
          this.$message.success("设置成功")
        } else {
          console.log("setSystemSettingInfo false", data.msg)
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.error("setSystemSettingInfo err", err)
        this.showNetErrMsg()
      })
    },

    onSaveSystemBg() {
      if (!this.BgChanged) {
        this.$message.warning("背景图未修改")
        return
      }
      if (this.fileBgList.length === 0) {
        this.doSetSystemSettingInfo("HOME_BACKGROUND", "")
        return;
      }

      let companyBg = `manager/sys-bj-${this.fileBgList[0].name}`
      uploadFile(this.fileBgList[0], companyBg)
      this.doSetSystemSettingInfo("HOME_BACKGROUND", companyBg)

    },

    onSaveHomeEnterSetting() {
      console.log("onSaveHomeEnterSetting", this.homeEnterVales)

      console.log("@@@", this.$refs.homeEnterTree.getCheckedKeys());
      this.homeEnterVales = this.$refs.homeEnterTree.getCheckedKeys()
      let content = this.homeEnterVales.join("|")
      this.doSetSystemSettingInfo("HOME_ENTER_SETTING", content)
    },
  },

  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("SYSTEM_SETTING_MODIFY")
        default:
          return false
      }
    }
  },

}

</script>

<style scoped lang="less">
.main-form {
  margin: 10px;
  min-height: 400px;
  //height: 50vh;

  .form-item-length {
    width: 300px;
  }
}

.table-box {
  //width: 100%;
}


.my-machine-table {
  margin-top: 20px;
  //margin-left: 2.5%;
  //width: 95%;
}

.center {
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.tree-box {
  display: flex;
  justify-content: center;
  gap: 100px;


  //margin: 20px;

  .left-tree {
    //margin-left: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #efefef;
    padding-top: 10px;

  }

  .right-tree {
    background-color: #efefef;
    padding-top: 10px;
    //margin-left: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .el-tree {
    border-radius: 10px;
    border: 1px solid #dcdfe6;
    padding: 20px 100px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 10px;
  }
}
</style>
